





























































import LinkCobranca from "@/pages/consultores/components/LinkCobranca.vue";
import {
  Consultor,
  ConsultoresService,
  GerarLinkResponse,
  TipoPlano
} from "@/services/consultores.service";
import { FeriadosService } from "@/services/feriados.service";
import ComboPlanos from "@/shared/components/combo-planos.vue";
import DataTable from "@/shared/components/data-table.vue";
import DatePicker from "@/shared/components/date-picker.vue";
import { date, dateTime, moeda, timeFromNow } from "@/shared/filters";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";

import { ToastOptions, ToastService } from "@/services/toast.service";

@Component({
  components: {
    DataTable,
    ComboPlanos,
    DatePicker,
    LinkCobranca,
  },
  filters: { date, dateTime, timeFromNow, moeda },
})
export default class Planos extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;
  loading = false;
  loadingDate = false;
  camposBoleto = false;
  consultor: Consultor | null = null;
  erroBoleto: string | null = "";
  promisePlanos: Promise<any[]> | null = null;
  showErroBoleto?: boolean = false;
  gerarCobranca = false;
  gerarCobrancaData?: string = "";
  gerarCobrancaPlano?: number | null = null;
  linkCharge: GerarLinkResponse | null = null;
  valid = false;

  dadosBoleto = {
    paymentLink: "",
    barcode: "",
  };

  headersPlanos = [
    { value: "descricao", text: "Plano" },
    { value: "valor", text: "Valor" },
    { value: "dataContratacao", text: "Contratação" },
    { value: "dataInicio", text: "Início" },
    { value: "dataExpiracao", text: "Fim" },
    { value: "status", text: "Status" },
  ];

  async mounted() {
    this.fetchPlanos(this.idConsultor);
    this.fetchConsultoresSelecionado(this.idConsultor);
  }

  async fetchPlanos(idConsultor: number) {
    this.loading = true;
    try {
      const planosService = await ConsultoresService.ListarPlanos(
        idConsultor,
        10
      );
      if (planosService) {
        planosService.forEach(function (item: any) {
          return { dataContratacao: item.dataInicio };
        });
        this.promisePlanos = planosService;
      }
    } finally {
      this.loading = false;
    }
  }

  async fetchConsultoresSelecionado(idConsultor: number) {
    this.loading = true;
    try {
      this.consultor = await ConsultoresService.ObterDadosConsultor(
        idConsultor
      );
    } finally {
      this.loading = false;
    }
  }

  public atualizarConsultorSelecionado() {
    this.fetchConsultoresSelecionado(this.idConsultor);
  }

  gerarLinkCobrancaClick() {
    this.gerarCobranca = true;
    this.gerarCobrancaPlano = null;
  }

  async verLinkClick(): Promise<void> {
    const form = this.$refs.form as any;
    if (form.validate()) {
      this.startLoader();

      this.linkCharge = await ConsultoresService.GerarLinkCobranca(
        this.idConsultor,
        this.setTipoPlano(this.gerarCobrancaPlano!)!
      )
        .finally(this.stopLoader);
    }
  }

  fechaAlertaBoleto() {
    this.showErroBoleto = false;
  }

  async calculaData(data: Date, dias: number): Promise<any> {
    if (dias == 0) {
      return data;
    }

    // adiciona/subtrai um dia
    data.setDate(data.getDate() + 1);
    //Verifica se o dia é util

    const isFimDeSemana = data.getDay() in { 0: "Sunday", 6: "Saturday" };
    const isFeriado = await this.verficaFeriado(data);

    //Se for util remove um dia
    if (!isFimDeSemana && !isFeriado) {
      dias--;
    }

    return this.calculaData(data, dias);
  }

  async verficaFeriado(data: Date) {
    let ehFeriado = false;
    const dia = data.getDate();
    const mes = data.getMonth() + 1;
    const ano = data.getFullYear();

    const feriados = await FeriadosService.listarFeriados(null);

    feriados.forEach(function (item) {
      if (item.ano == null) {
        if (item.dia == dia && item.mes == mes) {
          ehFeriado = true;
        }
      } else {
        if (item.dia == dia && item.mes == mes && item.ano == ano) {
          ehFeriado = true;
        }
      }
    });
    return ehFeriado;
  }
  gerarNovaCobranca() {
    this.gerarCobranca = false;
    this.camposBoleto = false;
    this.gerarCobrancaPlano = null;
  }

  setTipoPlano(status: number) {
    switch (status) {
      case 1:
        return TipoPlano["Gratis"];
      case 2:
        return TipoPlano["MensalLite"];
      case 3:
        return TipoPlano["TrimestralLite"];
      case 5:
        return TipoPlano["SemestralLite"];
      case 6:
        return TipoPlano["AnualLite"];
      case 7:
        return TipoPlano["BonusLite"];
      case 8:
        return TipoPlano["Mensal"];
      case 9:
        return TipoPlano["Trimestral"];
      case 10:
        return TipoPlano["Semestral"];
      case 11:
        return TipoPlano["Anual"];
      case 12:
        return TipoPlano["Bonus"];
      case 13:
        return TipoPlano["MensalEssencialConectada"];
      case 14:
        return TipoPlano["TrimestralEssencialConectada"];
      case 15:
        return TipoPlano["SemestralEssencialConectada"];
      case 16:
        return TipoPlano["AnualEssencialConectada"];
      case 17:
        return TipoPlano["BonusEssencialConectada"];
      case 18:
        return TipoPlano["MensalSuperConectada"];
      case 19:
        return TipoPlano["TrimestralSuperConectada"];
      case 20:
        return TipoPlano["SemestralSuperConectada"];
      case 21:
        return TipoPlano["AnualSuperConectada"];
      case 22:
        return TipoPlano["BonusSuperConectada"];
      case 23:
        return TipoPlano["MensalHiperConectada"];
      case 24:
        return TipoPlano["TrimestralHiperConectada"];
      case 25:
        return TipoPlano["SemestralHiperConectada"];
      case 26:
        return TipoPlano["AnualHiperConectada"];
      case 27:
        return TipoPlano["BonusHiperConectada"];
    }
  }

  setStatusPlano(status: number) {
    switch (status) {
      case 0:
        return "Cadastrado";
      case 1:
        return "Aguardando Pagamento";
      case 2:
        return "Ativo";
      case 3:
        return "Expirado";
      case 4:
        return "Contratado";
      case 9:
        return "Cancelado";
    }
  }

  copy(text: string) {
    const message: ToastOptions = {
      message: "",
      position: "bottom-end",
      duration: 10000,
    };

    navigator.clipboard
      .writeText(text)
      .then(() => {
        message.message = "Texto copiado com sucesso!";
        message.type = "success";
        message.duration = 3000;
      })
      .catch(() => {
        message.message =
          "Não foi possivel copiar o texto, tente novamente mais tarde";
        message.type = "error";
      })
      .finally(() => ToastService.open(message));
  }
}
